import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const NotebookDocumentSchema = withDefaults({
  type: 'notebook-document',
  fields: [
    { kind: 'attribute', name: 'notebookId' },
    { kind: 'attribute', name: 'filename' },
    { kind: 'attribute', name: 'contentType' },
    { kind: 'attribute', name: 'byteSize' },
    { kind: 'attribute', name: 'state' },
    { kind: 'attribute', name: 'failureReason' },
    { kind: 'attribute', name: 'processedAt' },
    { kind: 'attribute', name: 'createdAt' },
    { kind: 'attribute', name: 'updatedAt' },
  ],
});

export default NotebookDocumentSchema;
